
const
	main = {
        className: 'map-main',
        // title: 'Queensland',
        width: 500,
        height: 650,
        zoomscale: [1, 1],
		responsive: true
    },
    cairns = {
        className: 'map-inset cairns',
        title: 'Cairns',
        width: 250,
        height: 250,
        scale: 11200,
        zoomscale: [1, 2],
        center: [145.7781, -16.9186]
    },
    townsville = {
        className: 'map-inset townsville',
        title: 'Townsville',
        width: 250,
        height: 250,
        scale: 19500,
        zoomscale: [1, 2],
        center: [146.6800, -19.340]
    },
    brisbane = {
        className: 'map-inset brisbane',
        title: 'Brisbane',
        width: 250,
        height: 250,
        scale: 13500,
        zoomscale: [1, 2],
        center: [153.0251, -27.4698],
		responsive: false
    },
    goldcoast = {
        className: 'map-inset goldcoast',
        title: 'Gold Coast',
        width: 250,
        height: 250,
        scale: 20000,
        zoomscale: [1, 2],
        center: [153.2900, -28.020]
    };

// export { main, cairns, townsville, brisbane, goldcoast };

export default { main, cairns, townsville, brisbane, goldcoast };



// WEBPACK FOOTER //
// ./src/config.js